import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../../../../../EmptyFragment';
import { findLink } from '../../../../../../../../../../LinkyLinky';
import { Link } from '../../../../../../../../../../Resource/Types';
import CopyToClipboard from './CopyToClipboard';

interface Props {
  links: ReadonlyArray<Link>;
}

function CopyButton({ links }: Props) {
  return findLink('shared-open-enrollment-short-link', links)
    .map((link) => <CopyToClipboard copyText={link.href} />)
    .getOrElse(emptyFragment);
}

export default observer(CopyButton);
